module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-register"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "register-form form-horizontal"
  }, [(_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "fa": "user",
      "mdi": "email",
      "placeholder": "Email",
      "value": _vm.credentials.email,
      "error": _vm.errors.email,
      "required": "true",
      "autofocus": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "text",
      "name": "name",
      "fa": "user",
      "mdi": "person_outline",
      "placeholder": "Username",
      "value": _vm.credentials.name,
      "error": _vm.errors.name,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "fa": "lock",
      "mdi": "lock",
      "placeholder": "Password",
      "value": _vm.credentials.password,
      "error": _vm.errors.password,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "fa": "lock",
      "mdi": "lock_outline",
      "placeholder": "Confirm Password",
      "value": _vm.credentials.password_confirmation,
      "error": _vm.errors.password_confirmation,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control submit"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                  Register\n                ")])])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06ade80a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_auth/Register.vue
// module id = 797
// module chunks = 1